import { DashboardPageLayout } from 'pages/Dashboard/components/styled';
import styled from 'styled-components';

export const ValueByLocationDashboardLayout = styled(DashboardPageLayout)`
    grid-template-areas:
        'head head'
        'value-by-location value-by-location';
    grid-template-rows: 8rem minmax(40rem, 1fr);
    grid-template-columns: 1fr 1fr;
`;
